/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { KTIcon } from "../../../helpers";
import { Dropdown1 } from "../../content/dropdown/Dropdown1";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../app/modules/auth";

type Props = {
  className: string;
};

const ListsWidget1: React.FC<Props> = ({ className }) => {
  const { currentUser } = useAuth()
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className="card-header border-0 pt-5">
        {/* <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold text-dark">Subscribed Models</span>
          <span className="text-muted mt-1 fw-semibold fs-7">
            Test to see the Magic
          </span>
        </h3> */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className="card-body pt-5">
        <div className="row">
          <div className="col-sm-12 col-lg-6">
            <Link to={currentUser?.username == "HAL" ? "/documentprocessing" : "/documentsdashboard" }>
              <div className="d-flex align-items-center mb-7"> 
                {/* begin::Symbol */}
                <div className="symbol symbol-50px me-5">
                  <span className="symbol-label bg-light-success">
                    <KTIcon
                      iconName="abstract-26"
                      className="fs-3x text-success"
                    />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className="d-flex flex-column">
                  <a
                    href="#"
                    className="text-dark text-hover-primary fs-2 fw-bold"
                  >
                    Intelligent Document Processing
                  </a>
                  {/* <span className="text-muted fw-semibold">
                    Project Manager
                  </span> */}
                </div>
                {/* end::Text */}
              </div>
            </Link>

            <Link to={"/summarization"}>
              <div className="d-flex align-items-center mb-7">
                {/* begin::Symbol */}
                <div className="symbol symbol-50px me-5">
                  <span className="symbol-label bg-light-warning">
                    <KTIcon iconName="pencil" className="fs-3x text-warning" />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className="d-flex flex-column">
                  <a
                    href="#"
                    className="text-dark text-hover-primary fs-2 fw-bold"
                  >
                    Document Summarization
                  </a>
                  {/* <span className="text-muted fw-semibold">Art Director</span> */}
                </div>
                {/* end::Text */}
              </div>
            </Link>

            <Link to={"/tagextraction"}>
              <div className="d-flex align-items-center mb-7">
                {/* begin::Symbol */}
                <div className="symbol symbol-50px me-5">
                  <span className="symbol-label bg-light-primary">
                    <KTIcon
                      iconName="ki-duotone ki-paper-clip"
                      className="fs-3x text-primary"
                    />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className="d-flex flex-column">
                  <a
                    href="#"
                    className="text-dark text-hover-primary fs-2 fw-bold"
                  >
                    Document Meta Tags Extraction
                  </a>
                  {/* <span className="text-muted fw-semibold">Lead Developer</span> */}
                </div>
                {/* end::Text */}
              </div>
            </Link>

            <Link to={"/customconversation"}>
              <div className="d-flex align-items-center mb-7">
                {/* begin::Symbol */}
                <div className="symbol symbol-50px me-5">
                  <span className="symbol-label bg-light-success">
                    <KTIcon
                      iconName="message-text-2"
                      className="fs-3x text-success"
                    />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className="d-flex flex-column">
                  <a
                    href="#"
                    className="text-dark text-hover-primary fs-2 fw-bold"
                  >
                    Custom ChatGPT Conversations
                  </a>
                  {/* <span className="text-muted fw-semibold">
                    Project Manager
                  </span> */}
                </div>
                {/* end::Text */}
              </div>
            </Link>
          </div>
          <div className="col-sm-12 col-lg-6">
            <Link to={"/resumeformater"}>
              <div className="d-flex align-items-center mb-7">
                {/* begin::Symbol */}
                <div className="symbol symbol-50px me-5">
                  <span className="symbol-label bg-light-danger">
                    <KTIcon
                      iconName="disconnect"
                      className="fs-3x text-danger"
                    />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className="d-flex flex-column">
                  <a
                    href="#"
                    className="text-dark text-hover-primary fs-2 fw-bold"
                  >
                    Resume Formater
                  </a>
                  {/* <span className="text-muted fw-semibold">DevOps</span> */}
                </div>
                {/* end::Text */}
              </div>
            </Link>

            <Link to={"/websitecategorization"}>
              <div className="d-flex align-items-center mb-7">
                {/* begin::Symbol */}
                <div className="symbol symbol-50px me-5">
                  <span className="symbol-label bg-light-info">
                    <KTIcon
                      iconName="security-user"
                      className="fs-3x text-info"
                    />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className="d-flex flex-column">
                  <a
                    href="#"
                    className="text-dark text-hover-primary fs-2 fw-bold"
                  >
                    Website Categorization
                  </a>
                  {/* <span className="text-muted fw-semibold">QA Managers</span> */}
                </div>
                {/* end::Text */}
              </div>
            </Link>

            <Link to={"/semanticsearch"}>
              <div className="d-flex align-items-center mb-7">
                {/* begin::Symbol */}
                <div className="symbol symbol-50px me-5">
                  <span className="symbol-label bg-light-primary">
                    <KTIcon
                      iconName="message-text-2"
                      className="fs-3x text-primary"
                    />
                  </span>
                </div>
                {/* end::Symbol */}
                {/* begin::Text */}
                <div className="d-flex flex-column">
                  <a
                    href="#"
                    className="text-dark text-hover-primary fs-2 fw-bold"
                  >
                    Custom Semantic Search
                  </a>
                  {/* <span className="text-muted fw-semibold">Lead Developer</span> */}
                </div>
                {/* end::Text */}
              </div>
            </Link>

            <div className="d-flex align-items-center mb-7">
              {/* begin::Symbol */}
              <div className="symbol symbol-50px me-5">
                <span className="symbol-label bg-light-primary">
                  <KTIcon iconName="add" className="fs-3x text-primary" />
                </span>
              </div>
              {/* end::Symbol */}
              {/* begin::Text */}
              <div className="d-flex flex-column">
                <a
                  href="#"
                  className="text-dark text-hover-primary fs-2 fw-bold"
                >
                  More to come...
                </a>
                {/* <span className="text-muted fw-semibold">Lead Developer</span> */}
              </div>
              {/* end::Text */}
            </div>
          </div>
        </div>
      </div>
      {/* end::Body */}
    </div>
  );
};

export { ListsWidget1 };
